// Framework and third-party non-ui
import React, { useContext } from 'react';
import { Switch, Route } from 'react-router-dom';

// App components
import Filter from 'components/Filter';
import TrailSearch from 'components/TrailSearch';
import TrailOptions from 'components/TrailOptions';
import { MapContext } from 'contexts/MapContext';

// JSON & Styles
import { StyledSubHeader } from './SubHeader-styled';

// Third-party components (buttons, icons, etc.)

const SubHeader = () => {
  const { sidebarSelection, setSidebarSelection } = useContext(MapContext);
  
  return (
    <StyledSubHeader data-testid="SubHeader">
      <Switch>
        <Route path="/details">
          <TrailSearch inputWidth={'48ch'} style={{marginLeft: '20px'}}/>
          <Filter />
        </Route>
      </Switch>
    </StyledSubHeader>
  );
};

export default SubHeader;
